import { BranchOffice } from '@api/BranchOffices/BranchOffice';
import BranchOfficeServ from '@api/BranchOffices/BranchOfficeServ';
import { UserType } from '@api/Users/User';

class BranchOfficesService {
    saveBranchOffice = (branchOffice: BranchOffice): Promise<BranchOffice> => {
        return new Promise(async (resolve, reject) => {
            try {
                branchOffice.status = true;
                const data = await BranchOfficeServ.saveBranchOffice(branchOffice);
                resolve(data);
            } catch (error) {
                reject('Error saving branch office: ' + error);
            }
        });
    };
    getBranchOffices = (filters?: any): Promise<BranchOffice[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await BranchOfficeServ.getBranchOffices(filters);
                resolve(data);
            } catch (error) {
                console.log(error);
                reject('Error getting branch offices: ' + error);
            }
        });
    };
    getBranchOffice = (branchOfficeId: string): Promise<BranchOffice> => {
        return new Promise(async (resolve, reject) => {
            try {
                const branchOffice = await BranchOfficeServ.getBranchOffice(branchOfficeId);
                resolve(branchOffice);
            } catch (error) {
                reject('Error getting branch office: ' + error);
            }
        });
    };

    toggleStatus = (branchOfficeId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await BranchOfficeServ.toggleStatus(branchOfficeId);
                resolve();
            } catch (error) {
                reject('Error updating branch office status: ' + error);
            }
        });
    };

    setInputUnavailability = (
        branchOfficeId: string,
        inputId: string,
        inputName: string,
        unavailable: boolean
    ): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await BranchOfficeServ.setInputUnavailability(branchOfficeId, inputId, inputName, unavailable);
                resolve();
            } catch (error) {
                reject('Error updating input availability: ' + error);
            }
        });
    };

    getTeam = (branchOfficeId: string): Promise<UserType[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const team = await BranchOfficeServ.getTeam(branchOfficeId);
                resolve(team);
            } catch (error) {
                reject('Error getting branch office team: ' + error);
            }
        });
    };
}
export default BranchOfficesService;
